import React from 'react';

interface Props {
    items: number;
}

export function RatingLoading({ items }: Props) {
    return (
        <div className="rating-container">
            <div className="rating">
                {new Array(items).fill(0).map((_, i) => (
                    <div key={i} className="rating-item rating-item--borderless">
                        <div className="shimmer shimmer--child" />

                        {[0,items - 1].includes(i) && <span className="rating-label shimmer" aria-hidden="true" />}
                    </div>
                ))}
            </div>
        </div>
    );
}